import { createBrowserRouter } from 'react-router';

import { App } from '../App';
import { Browse, Details } from './routes';

export const router = createBrowserRouter([
	{
		path: Browse.path,
		Component: App,
		children: [
			{
				index: true,
				lazy: async () => {
					const [Component] = await Promise.all([import('../pages/browse')]);
					return { Component: Component.default };
				},
			},
			{
				path: Details.path,
				lazy: async () => {
					const [Component] = await Promise.all([import('../pages/details')]);
					return { Component: Component.default };
				},
			},
		],
	},
], {
	basename: process.env.REACT_ROUTER_BASENAME || ''
});
